export const EMPLOYER_ROUTES = {
  dashboard: '/employer-dashboard',
  profile: '/employer/profile',
  settings: '/employer/settings',
};

export const SEEKER_ROUTES = {
  dashboard: '/job-seeker-dashboard',
  profile: '/job-seeker/profile',
  settings: '/job-seeker/settings',
};

export const ADMIN_ROUTES = {
  dashboard: '/admin-dashboard',
};
